import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import VerifyEmailPage from './pages/auth/VerifyEmailPage';
import DashboardPage from './pages/DashboardPage';
import TherapistsPage from './pages/TherapistsPage';
import AppointmentsPage from './pages/AppointmentsPage';
import JournalPage from './pages/JournalPage';
import SettingsPage from './pages/SettingsPage';
import ProfilePage from './pages/profile/ProfilePage';
import { TherapistProfilePage } from './pages/therapist/TherapistProfilePage';
import { BookingPage } from './pages/booking/BookingPage';
import { VideoSessionPage } from './pages/session/VideoSessionPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/therapist/:id" element={<TherapistProfilePage />} />

        {/* Booking routes */}
        <Route
          path="/book/:therapistId"
          element={
            <ProtectedRoute>
              <BookingPage />
            </ProtectedRoute>
          }
        />

        {/* Video session route */}
        <Route
          path="/session/:bookingId"
          element={
            <ProtectedRoute>
              <VideoSessionPage />
            </ProtectedRoute>
          }
        />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="therapists" element={<TherapistsPage />} />
          <Route path="appointments" element={<AppointmentsPage />} />
          <Route path="journal" element={<JournalPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* Catch all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
